var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4147 5.0581C16.7312 4.37468 15.6232 4.37468 14.9398 5.05809L5.53638 14.4615C5.35419 14.6437 5.21448 14.8639 5.12723 15.1063L4.29182 17.4273C3.79038 18.8205 5.13792 20.168 6.53107 19.6666L8.85209 18.8311C9.09452 18.7439 9.31468 18.6042 9.49687 18.422L18.9003 9.01859C19.5837 8.33517 19.5837 7.22713 18.9003 6.54371L17.4147 5.0581ZM16.0004 6.11875C16.0981 6.02112 16.2564 6.02112 16.354 6.11876L17.8396 7.60437C17.9372 7.702 17.9372 7.86029 17.8396 7.95793L8.43621 17.3613C8.41018 17.3874 8.37873 17.4073 8.3441 17.4198L6.02307 18.2552C5.82405 18.3268 5.63155 18.1343 5.70318 17.9353L6.53859 15.6143C6.55105 15.5796 6.57101 15.5482 6.59704 15.5222L16.0004 6.11875ZM12 18.25C11.5858 18.25 11.25 18.5858 11.25 19C11.25 19.4142 11.5858 19.75 12 19.75H18C18.4142 19.75 18.75 19.4142 18.75 19C18.75 18.5858 18.4142 18.25 18 18.25H12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.77f4fefb728185920e5e2d07126412db.svg";
export { ForwardRef as ReactComponent };